import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";

export default class UpdateUnreadedMessageIdList extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "updateUnreadedMessageIdList";
    }

    public receive(payload: CometOperatorApplication.UpdateUnreadedMessageIdListCometMessageOpenApiModel): void {
        ClientUserdataStore.UPDATE_UNREADED_MESSAGE_ID_LIST({
            username: payload.username,
            messageIds: payload.messageIds,
            adminMessageIds: payload.adminMessageIds,
            mentionMessageIds: payload.mentionMessageIds,
            crossOperatorConversationUnreadMessageCount: payload.crossOperatorConversationUnreadMessageCount
        });
    }

}